import moment from 'moment-timezone';
import type { RoomsOperatingReportDto } from './RoomsOperatingReportDto';
import type { RoomsOperatingReport, RoomsOperatingMetric, RoomsOperatingRanges } from 'model/RoomsOperatingReport';

const toRange = (start: string, end: string, tz: string) => ({
    start: moment(start).tz(tz).startOf('day'),
    end: moment(end).tz(tz).endOf('day')
});

export const convertToRoomsOperatingReport = (dto: RoomsOperatingReportDto, timeZone: string): RoomsOperatingReport => {
    const ranges: RoomsOperatingRanges = {
        today: toRange(dto.ranges.today.start, dto.ranges.today.end, timeZone),
        todayLy: toRange(dto.ranges.today_ly.start, dto.ranges.today_ly.end, timeZone),
        mtd: toRange(dto.ranges.mtd.start, dto.ranges.mtd.end, timeZone),
        mtdLy: toRange(dto.ranges.mtd_ly.start, dto.ranges.mtd_ly.end, timeZone),
        ytd: toRange(dto.ranges.ytd.start, dto.ranges.ytd.end, timeZone),
        ytdLy: toRange(dto.ranges.ytd_ly.start, dto.ranges.ytd_ly.end, timeZone)
    };

    const metrics: RoomsOperatingMetric[] = (dto.metrics ?? []).map(m => ({
        key: m.key,
        label: m.label,
        kind: m.kind,
        section: m.section,
        today: { value: Number(m.today?.value ?? 0), ly: Number(m.today?.ly ?? 0) },
        mtd: { value: Number(m.mtd?.value ?? 0), ly: Number(m.mtd?.ly ?? 0) },
        ytd: { value: Number(m.ytd?.value ?? 0), ly: Number(m.ytd?.ly ?? 0) }
    }));

    return {
        ranges,
        summary: {
            roomsAvailable: Number(dto.summary?.rooms_available ?? 0),
            roomsOccupied: {
                value: Number(dto.summary?.rooms_occupied?.value ?? 0),
                pct: Number(dto.summary?.rooms_occupied?.pct ?? 0)
            },
            vacantRooms: {
                value: Number(dto.summary?.vacant_rooms?.value ?? 0),
                pct: Number(dto.summary?.vacant_rooms?.pct ?? 0)
            },
            petsServed: Number(dto.summary?.pets_served ?? 0),
            adr: Number(dto.summary?.adr ?? 0),
            revpar: Number(dto.summary?.revpar ?? 0),
            totalRoomRevenue: Number(dto.summary?.total_room_revenue ?? 0)
        },
        metrics
    };
};
